import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography } from '@mui/material';
import { SLOT_COLOR, SLOT_ICON } from './promptNodeConfig';

export default function PromptSlotNode({ data, selected }) {
  const variantCount = data.variants?.length || 0;
  const hasFallback = !!data.fallback;
  const summary = variantCount === 0
    ? (hasFallback ? 'fallback only' : 'no variants')
    : `${variantCount} variant${variantCount !== 1 ? 's' : ''}${hasFallback ? ' + fallback' : ''}`;

  const borderColor = data.isOrphaned ? '#888' : SLOT_COLOR;
  const opacity = data.isOrphaned ? 0.55 : 1;

  return (
    <Box
      sx={{
        position: 'relative',
        border: `2px solid ${borderColor}`,
        borderRadius: 2,
        width: 220,
        bgcolor: 'background.paper',
        boxShadow: selected ? `0 0 0 3px ${borderColor}44` : 1,
        opacity,
      }}
    >
      <Handle id="target-top" type="target" position={Position.Top} style={{ background: borderColor }} />
      <Handle id="target-left" type="target" position={Position.Left} style={{ background: borderColor }} />
      <Box
        sx={{
          px: 1.5,
          py: 0.75,
          bgcolor: `${borderColor}22`,
          borderRadius: '6px 6px 0 0',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography sx={{ color: borderColor, fontSize: 13, fontFamily: 'monospace', fontWeight: 'bold' }}>
          {SLOT_ICON}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 'bold', color: borderColor, fontSize: 11, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {data.name || 'unnamed'}
        </Typography>
        {data.isOrphaned && (
          <Typography sx={{ fontSize: 10, color: '#888' }} title="Not connected to any prompt">⚠</Typography>
        )}
      </Box>
      <Box sx={{ px: 1.5, py: 1 }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 10 }}>
          {summary}
        </Typography>
      </Box>
    </Box>
  );
}
